import { Component } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import {UisService} from "../../../service/services/misc/uis/uis.service";
import { WizardDialogComponent } from "../wizard-dialog/wizard-dialog.component";
import {DialogService} from "../../../service/services/misc/dialog/dialog.service";

@Component({
    selector: 'app-wizard-side-dialog',
    templateUrl: '../wizard-dialog/wizard-dialog.component.html',
    styleUrls: ['../wizard-dialog/wizard-dialog.component.scss', '../dialog/dialog.component.scss'],
    standalone: false
})
export class WizardSideDialogComponent extends WizardDialogComponent {
    constructor(public override dialogRef: DialogRef, public override uisService: UisService, public override dialogService: DialogService) {
        super(dialogRef, uisService, dialogService);
    }
}
